import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'

import { LocationCard } from './locationCard'

export const LocationSummary = () => {
	const selectedLocation = useCartStore.use.location()

	if (!selectedLocation) return null

	return (
		<div className={cn('max-w-[345px]')}>
			<LocationCard
				key={selectedLocation.hotelCode}
				title={selectedLocation.title}
				hotelCode={selectedLocation.hotelCode}
				classification={selectedLocation.classification}
				image={selectedLocation.image}
				onSelect={() => {}}
				isSummary
			/>
		</div>
	)
}
